import Download from './components/Contents/Worksheet/Download';
import { DesktopPreviewer, MobilePreviewer } from './components/Contents/Worksheet/PdfPreviewer';
import * as Branding from './components/Contents/Worksheet/Branding/UploadLogo';

import OldDownload from './components/Contents/Worksheet/OldDownload';
import { DesktopPreviewer as OldDesktopPreviewer, MobilePreviewer as OldMobilePreviewer } from './components/Contents/Worksheet/OldPdfPreviewer';

window.Contents = {
    Worksheet: {
        Download,
        DesktopPreviewer,
        MobilePreviewer,
    
        Branding,

        OldDownload,
        OldDesktopPreviewer,
        OldMobilePreviewer,
    }
};
